import React from "react";

const Experience = () => {
  return (
    <div name="experience" className="w-full min-h-screen bg-[#0a192f] text-gray-300 scroll-mt-20">
      <div className="flex flex-col justify-center items-center w-full h-full py-16">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-violet-600">
              Experience
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="text-4xl font-bold">
            <p>
              DevOps / SRE &amp; Platform Engineering
            </p>
          </div>
          <div className="space-y-4 text-gray-300">
            <p>
              My core focus is Kubernetes platform engineering on AWS and GCP —
              driving initiatives around dynamic autoscaling, GitOps-driven delivery,
              security hardening, and cloud cost optimisation. I manage infrastructure
              as code end-to-end and build CI/CD pipelines that support dynamic
              environments and progressive delivery strategies.
            </p>
            <p>
              Passionate about AI-driven DevOps tooling — architecting agentic
              systems that integrate with deployment pipelines and knowledge sources
              to give engineering teams faster, smarter workflows. I work with LLMs
              and RAG patterns, including unified abstraction layers for
              multi-model flexibility and cost tracking.
            </p>
            <p>
              Beyond that, I bring broad experience across the full DevOps stack:
              infrastructure as code, observability, security, and building tools
              with Python and Go — including AI-powered tooling.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
